<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form
            v-if="isSearch"
            :model="queryForm"
            ref="form"
            label-width="80px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-plus"
                        @click="addShopProductCategory"
                    >新建
                    </el-button>
                    <el-button
                        type="warning"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        :disabled="multipleSelection.length != 1"
                        @click="editShopProductCategory(null)"
                    >修改
                    </el-button>
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteShopProductCategory(null)"
                    >删除
                    </el-button>
                </div>

                <div class="icon-group">
          <span
              class="icon-box"
              @click="refreshShopProductCategoryList"
          >
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
                </div>

            </div>
            <!-- 列表数据 -->
            <el-table
                :data="shopProductCategoryList"
                row-key="id"
                size="small"
                height="100%"
                :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    align="center"
                    type="selection"
                    min-width="10%"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="left"
                    prop="categoryName"
                    label="分类名称"
                    min-width="20%"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    label="分类图片"
                    min-width="20%"
                >
                    <template slot-scope="scop">
                        <el-image
                            @click='updateSrcList(scop.row.categoryPic)'
                            style="width: 30px; height: 30px"
                            :src="scop.row.categoryPic"
                            :preview-src-list="srcList"
                        ></el-image>
                    </template>
                </el-table-column>
                <el-table-column

                    align="center"
                    prop="sort"
                    label="分类排序"
                    min-width="20%"
                >
                    <template slot-scope="scop">
                        <el-input-number
                            style="width:150px"
                            v-model="scop.row.sort"
                            @change="changeSort(scop.row)"
                            size="small"
                            label=""
                            :min="1"
                            :max="1000"
                            :step="1"
                            :controls="true"
                            controls-position="both"
                        >
                        </el-input-number>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="操作"
                    min-width="35%"
                >
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="checkShopProductCategory(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editShopProductCategory(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="deleteShopProductCategory(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                            <div @click="addChildProductCategory(scop.row.id)">
                                <Icon size="16">
                                    <AddCircle24Regular />
                                </Icon>
                                <span class="operation-label">添加下级商品分类</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"

                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="shopProductCategoryStates[shopProductCategoryState]"
                :visible.sync="showDialog"
                width="400px"
                @close="closeDialog"
            >
                <div>
                    <el-form
                        :model="shopProductCategory"
                        ref="shopProductCategoryForm"
                        :rules="rules"
                        label-width="80px"
                        :inline="true"
                        size="mini"
                    >
                        <el-form-item
                            label="分类名称"
                            prop="categoryName"
                        >
                            <el-input
                                size="small"
                                style="width: 200px"
                                v-model="shopProductCategory.categoryName"
                                :disabled="shopProductCategoryState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="父级分类"
                            prop="parentId"
                        >
                            <el-select
                                clearable
                                style="width: 200px"
                                v-model="shopProductCategory.parentId"
                                placeholder="请选择"
                                :disabled="shopProductCategoryState == 'check'"
                                size="small"
                            >
                                <el-option
                                    label="顶级分类"
                                    :value="'0'"
                                ></el-option>
                                <el-tree
                                    :data="shopProductCategoryList"
                                    :props="treeProps"
                                    :render-after-expand="false"
                                >
                                    <div
                                        class="custom-tree-node flex items-center"
                                        slot-scope="{ node, data }"
                                    >
                                        <el-option
                                            :label="node.label"
                                            :value="data.id"
                                        ></el-option>
                                    </div>
                                </el-tree>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="分类图片" prop="categoryPic">
                            <el-upload
                                action=""
                                :disabled="shopProductCategoryState == 'check'"
                                class="avatar-uploader"
                                :show-file-list="false"
                                :http-request="uploadAvatar"
                                style="width: 200px"
                            >
                                <img
                                    v-if="shopProductCategory.categoryPic"
                                    :src="shopProductCategory.categoryPic"
                                    class="avatar"
                                />
                                <i
                                    v-else
                                    class="el-icon-plus avatar-uploader-icon"
                                ></i>
                            </el-upload>
                        </el-form-item>
                        <el-form-item
                            label="分类排序"
                            prop="sort"
                        >
                            <el-input-number
                                style="width: 200px"
                                :disabled="shopProductCategoryState == 'check'"
                                v-model="shopProductCategory.sort"
                                size="small"
                                label=""
                                :min="1"
                                :max="100000"
                                :step="1"
                                :controls="true"
                                controls-position="both"
                            >
                            </el-input-number>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot="footer"
                    class="flex justify-end"
                >
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button
                        type="primary"
                        @click="submitForm"
                        v-if="shopProductCategoryState != 'check'"
                    >确定
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular, AddCircle24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        AddCircle24Regular
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopProductCategoryList();
                this.getShopProductCategoryList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopProductCategoryList();
                this.getShopProductCategoryList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            queryForm: {
                id: '', //ID
                categoryName: '', //产商品分组名
                categoryPic: '', //类别图片
                parentId: '', //父级
                sort: '', //分组排序
                createUserId: '', //创建人
                createTime: '', //创建时间
                updateUserId: '', //更新人
                updateTime: '', //更新时间
                deleteFlag: '' //是否删除
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopProductCategoryState: 'add',
            shopProductCategoryStates: {
                add: '新建商品分类',
                check: '查看商品分类',
                edit: '修改商品分类',
                addChild: '添加下级商品分类'
            },

            multipleSelection: [],
            shopProductCategoryList: [],
            imgName: '',
            shopProductCategory: {
                id: '', //ID
                categoryName: '', //商品分组名
                categoryPic: '', //类别图片
                parentId: '', //父级
                sort: '10', //分组排序
                createUserId: '', //创建人
                createTime: '', //创建时间
                updateUserId: '', //更新人
                updateTime: '', //更新时间
                deleteFlag: '' //是否删除
            },
            btnLoading: false,
            rules: {
                categoryName: [{ required: true, message: '商品分组名不能为空', trigger: 'blur' }]
            },
            treeProps: {
                children: 'children',
                label: 'categoryName'
            },
            srcList: ['']//大图预览
        };
    },
    created() {
        this.getShopProductCategoryList();
    },
    methods: {
        changeSort(category) {
            console.log('1111111', category);
            delete category.shopProductList;
            delete category.children;
            post(`/washcloud/productcategory/edit`, { ...category }).then((res) => {
                if (res.success) {
                    this.$message({
                        message: `编辑成功`,
                        type: 'success',
                        duration: 2000
                    });
                    this.getShopProductCategoryList();

                }
            });
        },
        search() {
            this.isSearch = !this.isSearch;
        },

        updateSrcList(src) {
            this.srcList[0] = src;
        },

        resetShopProductCategoryList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopProductCategoryList = [];
        },
        resetDialog() {
            this.shopProductCategoryState = 'add';
            this.showDialog = false;
            this.shopProductCategory = {
                id: '', //ID
                categoryName: '', //商品分组名
                categoryPic: '', //类别图片
                parentId: '', //父级
                sort: '10', //分组排序
                createUserId: '', //创建人
                createTime: '', //创建时间
                updateUserId: '', //更新人
                updateTime: '', //更新时间
                deleteFlag: '' //是否删除
            };
            this.getShopProductCategoryList();
        },
        closeDialog() {
            this.resetDialog();
        },
        submitForm() {
            if (this.shopProductCategoryState == 'add') {
                this.$refs.shopProductCategoryForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/washcloud/productcategory/add`, { ...this.shopProductCategory }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopProductCategoryList();
                                this.resetDialog();
                                this.getShopProductCategoryList();
                            }
                        });
                    }
                });
            } else if (this.shopProductCategoryState == 'edit') {
                this.$refs.shopProductCategoryForm.validate((valid) => {
                    if (valid) {
                        console.log('submit', this.shopProductCategory);
                        delete this.shopProductCategory.children;
                        post(`/washcloud/productcategory/edit`, { ...this.shopProductCategory }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopProductCategoryList();
                                this.resetDialog();
                                this.getShopProductCategoryList();
                            }
                        });
                    }
                });
            } else if (this.shopProductCategoryState == 'addChild') {
                this.$refs.shopProductCategoryForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/washcloud/productcategory/add`, { ...this.shopProductCategory }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopProductCategoryList();
                                this.resetDialog();
                                this.getShopProductCategoryList();
                            }
                        });
                    }
                });
            }
        },
        addChildProductCategory(departmentId) {
            this.shopProductCategory.parentId = departmentId;
            this.showDialog = true;
            this.shopProductCategoryState = 'addChild';
        },
        addShopProductCategory() {
            this.showDialog = true;
            this.shopProductCategoryState = 'add';
        },
        checkShopProductCategory(shopProductCategoryId) {
            console.log(shopProductCategoryId);
            this.currentShopProductCategoryId = shopProductCategoryId;
            this.getShopProductCategoryById();
            this.showDialog = true;
            this.shopProductCategoryState = 'check';
        },
        editShopProductCategory(shopProductCategoryId) {
            //console.log('category', shopProductCategoryId);
            if (shopProductCategoryId) {
                this.currentShopProductCategoryId = shopProductCategoryId;
                this.getShopProductCategoryById();
            } else {
                this.shopProductCategory = { ...this.shopProductCategory, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.shopProductCategoryState = 'edit';
        },
        deleteShopProductCategory(shopProductCategoryId) {
            let ids = '';
            if (shopProductCategoryId) {
                ids = shopProductCategoryId;
            } else {
                ids = this.multipleSelection.map((shopProductCategory) => shopProductCategory.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/washcloud/productcategory/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopProductCategoryList();
                            this.getShopProductCategoryList();
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshShopProductCategoryList() {
            this.resetShopProductCategoryList();
            this.getShopProductCategoryList();
        },
        getShopProductCategoryList(query = {}) {
            this.loading = true;
            get(`/washcloud/productcategory/findAllAsTree`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.shopProductCategoryList = res.treeData;
                }
            });
        },
        getShopProductCategoryById() {
            get(`/washcloud/productcategory/get`, { id: this.currentShopProductCategoryId }).then((res) => {
                if (res.success) {
                    this.shopProductCategory = { ...this.shopProductCategory, ...res.shopProductCategory };
                    delete this.shopProductCategory.shopProductList;
                    if (this.shopProductCategory.parentId == 0 || this.shopProductCategory.parentId == null) {
                        // this.shopProductCategory.parentId = ''; 暂时注释
                        this.shopProductCategory.parentId = '0';
                    }
                }
            });
        },
        /**
         * 导出出岗位信息
         */
        exportShopProductCategoryList() {
            this.btnLoading = true;
            exprotExcel(`/washcloud/productcategory/export`, this.shopProductCategory, this.btnLoading);
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/washcloud/productcategory/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },

        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/washcloud/productcategory/importData`, formData);
            this.refreshShopProductCategoryList();
        },
        uploadAvatar(params) {
            console.log({ params });
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg'];
            if (!types.includes(file.type)) {
                this.$message({
                    message: '只能上传图片格式的文件，png.jpg或者jpeg',
                    type: 'error',
                    showClose: true,
                    duration: 2000
                });
            }
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload(`/mpp/image/upload`, formData).then((res) => {
                console.log({ res });
                if (res.success) {

                    this.shopProductCategory.categoryPic = res.url;
                    this.imgName = res.url;
                    console.log();
                }
            });
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopProductCategoryList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getShopProductCategoryList();
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    button {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}

::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 200px;
    text-align: center;
}

.avatar {
    width: 200px;
    height: 200px;
    display: block;
}
</style>
